import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "350px",
  },

  mobile_wrapper: {
    width: "100vw",
    height: "350px",
    overflowX: "scroll",
  },

  desktop_wrapper: {
    width: "100%",
    height: "350px",
  },

  mobile_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100vw",
    height: "350px",
    overflowX: "hidden",
  },
}));

export default useStyles;
